interface BicoinLogoProps {
  height?: number
  className?: string
}

export function BicoinLogo({ height = 36, className = '' }: BicoinLogoProps) {
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }} className={className}>
      <svg height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="32" height="32" rx="8" fill="#1CD4A7" />
        <text x="8" y="23" fontFamily="'DM Sans', Arial, sans-serif" fontWeight="800" fontSize="20" fill="#000000">B</text>
      </svg>
      <span className="bicoin-logo-text" style={{ fontWeight: 700, fontSize: height * 0.55, fontFamily: "'DM Sans', Arial, sans-serif", letterSpacing: '-0.3px', lineHeight: 1 }}>Bicoin</span>
    </div>
  )
}
